export default __webpack_public_path__ + "static/media/boombox.91d8de51.png";